export default __webpack_public_path__ + "static/media/user.1e4ee638.svg";